module.exports = __webpack_public_path__ + "static/media/notificationfilled_orange.f4faca4d.png";